<template>
    <div style="width: 100%" class="d-flex align-center justify-center">
        <template v-for="tab in keyTabs">
            <div
                    class="mx-5 text-h6 font-weight-regular"
                    :key="tab.key"
                    @click="$emit('input', tab.key)"
                    :class="tab.key === value ? 'nav-bar-tab-selected' : 'nav-bar-tab'"
            >
                {{tab.text}}
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
      keyTabs() {
        return this.tabs.map((v, i) => ({key: v.key || i, text: v.text || v}))
      }
    }
}
</script>

<style scoped>
    .nav-bar-tab{
        cursor: pointer;
        color: rgba(255,255,255,0.4);
        -webkit-transition: color .2s ease-out;
        -moz-transition: color .2s ease-out;
        -o-transition: color .2s ease-out;
        transition: color .2s ease-out;
    }

    .nav-bar-tab:hover{
        color: rgba(255,255,255,1);
    }

    .nav-bar-tab-selected{
        cursor: pointer;
        color: rgba(255,255,255,1);
    }
</style>